import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CourseImageWrapper from './CourseImageWrapper';
import CourseCardWrapper from './CourseCardWrapper';
import CourseInfoWrapper from './CourseInfoWrapper';
import { priceFormater } from '../../helpers/formatNumbers';
import Flex from '../Flex';
import Typo from '../Typo';
import Button from '../Button';
import Icon from '../Icon';
import Figure from '../Figure';
import theme from '../theme';
import { themeGradientBg, toRgba } from '../theme/colors';
import ImagePlaceholder from './ImagePlaceholder';

const ActionsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const BundleTag = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  background-color: ${({ $bgColor }) => $bgColor};
  padding: 6px 8px;
  border-radius: 8px;
  z-index: 1;
`;

const CourseCard = ({ courseInfo, goToCoursePage, addToCart, showProgress, showButtons, inGrid, showPackageInfo, hideVAT, storeTheme, ownerName }) => {
  const { t } = useTranslation();

  const { coverImage, price, currency, coverUrl } = courseInfo;
  const imageUrl = !coverImage ? coverUrl : Array.isArray(coverImage) ? coverImage[0]?.url : coverImage?.url;

  const isPackage = courseInfo?.type === 2;
  const packageSize = courseInfo?.courses?.length;

  const handleBuy = (e) => {
    e.stopPropagation();
    addToCart(courseInfo);
  };

  const clickOnCard = () => {
    if (!showPackageInfo) goToCoursePage(courseInfo, courseInfo.type === 2);
    else showPackageInfo(courseInfo);
  };

  const handleShowPackageInfo = (e) => {
    e.stopPropagation();
    showPackageInfo(courseInfo);
  };

  return (
    <CourseCardWrapper onClick={clickOnCard} inGrid={inGrid}>
      <CourseImageWrapper>
        <Figure.Rectangle>
          {isPackage && packageSize && (
            <BundleTag $bgColor={toRgba(theme.colors.NEU_999, 0.65)}>
              <Typo.Info $themeColor={theme.colors.NEU_999}>{t('webshop.packageCoursesCount', { number: packageSize })}</Typo.Info>
            </BundleTag>
          )}
          {!imageUrl ? (
            <ImagePlaceholder $backgroundColor={themeGradientBg(storeTheme.color)} ownerLogo={storeTheme?.logoUrl} />
          ) : (
            <img src={imageUrl} alt='CourseImage' loading='lazy' />
          )}
        </Figure.Rectangle>
      </CourseImageWrapper>

      <CourseInfoWrapper course={courseInfo} showProgress={showProgress} showButtons ownerColor={storeTheme?.color} ownerName={ownerName}>
        {showButtons && (
          <ActionsWrapper>
            <Button $asText onClick={clickOnCard}>
              {t('globals.moreInfo')}
            </Button>
            <Flex justify='space-between' width='100%'>
              <Flex direction='column' align='flex-start'>
                <Typo.TextTitle>{priceFormater(price, hideVAT, currency)}</Typo.TextTitle>
                {hideVAT && <Typo.Info>{t('globals.priceExcVat')}</Typo.Info>}
              </Flex>
              {+price?.gross > 0 && (
                <Button $variant='action' onClick={handleBuy}>
                  {t('webshop.buy')}
                </Button>
              )}
            </Flex>
          </ActionsWrapper>
        )}
        {showPackageInfo && (
          <Flex justify='end'>
            <Button $themeColor={storeTheme.color} onClick={handleShowPackageInfo} $variant='themed'>
              {t('globals.moreInfo')}
            </Button>
          </Flex>
        )}
      </CourseInfoWrapper>
    </CourseCardWrapper>
  );
};

export default CourseCard;
